export default __webpack_public_path__ + "static/media/gnosis1.22d88877.png";